import { FormErrorMessage, Text } from '@chakra-ui/core'
import { SearchableMenu, SearchableMenuItem } from 'components/AdminConsole/commonUI/SearchableMenu'
import { StyledFormControl, StyledFormLabel } from 'components/AdminConsole/commonUI/styles'
import useLocaleText from 'components/useLocaleText'
import { isNumber } from 'lodash'
import { RefreshCcw } from 'lucide-react'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

interface CampaignDropDownProps {
  name: string
  label: string
  menuItems: SearchableMenuItem[]
}

export const CampaignDropDown = ({ name, label, menuItems }: CampaignDropDownProps) => {
  const { errors, control, setValue, clearError, watch } = useFormContext()
  const value = watch(`products_cluster_data.${name}`)

  const t_is_required = useLocaleText('is_required', true)
  const admin_select_placeholder = useLocaleText('admin_select_placeholder')

  return (
    <StyledFormControl isInvalid={!!errors.products_cluster_data?.[name]} w={{ base: '100%', md: '50%' }}>
      <StyledFormLabel required>
        <RefreshCcw size={18} strokeWidth={2.5} />
        <Text>{label}</Text>
      </StyledFormLabel>

      <Controller
        name={`products_cluster_data.${name}`}
        control={control}
        rules={{ required: `${label} ${t_is_required}` }}
        as={
          <SearchableMenu
            isInvalid={!!errors.products_cluster_data?.[name]}
            isShowSearch={false}
            items={menuItems}
            selectedId={isNumber(value) ? value?.toString() : value}
            placeholder={admin_select_placeholder}
            isLocalTranslation={true}
            onSelect={(item) => {
              const value = name.includes('rank_by') || name.includes('competition_type') ? Number(item.id) : item.id
              setValue(`products_cluster_data.${name}`, value)
              clearError(`products_cluster_data.${name}`)
            }}
          />
        }
      />

      <FormErrorMessage style={{ columnGap: '10px' }}>
        {errors.products_cluster_data?.[name] && errors.products_cluster_data?.[name].message}
      </FormErrorMessage>
    </StyledFormControl>
  )
}
